import { IonCol, IonGrid, IonImg, IonRow } from '@ionic/react';
// Slides
import { SwiperSlide } from 'swiper/react';

import IBkneeflexionmidstance1 from '@/pages/ReportV2/components/Modals/assets/IBkneeflexionmidstance1.png';
import IBkneeflexionmidstance2 from '@/pages/ReportV2/components/Modals/assets/IBkneeflexionmidstance2.png';
import styles from '@/pages/ReportV2/components/Modals/ModalContent.module.css';

import { VerticalSwiper } from '@/components/swiper';

export const KneeFlexionMidstanceModalContent = () => {
  return (
    <>
      <VerticalSwiper>
        <SwiperSlide>
          <IonGrid className='' style={{ height: '100%' }}>
            <IonRow className='ion-align-items-center ion-justify-content-center' style={{ height: '100%' }}>
              <IonCol className='ion-no-padding' size='12' size-lg='5' size-xl='5'>
                <div>
                  <IonImg class={styles.avatar} src={IBkneeflexionmidstance1} />
                </div>
              </IonCol>
              <IonCol size='12' size-lg='6' size-xl='6'>
                <div>
                  During single limb support, one leg alone carries the full body weight and keeping it balanced. The
                  knee joint is put under serious pressure throughout this phase, reaching the climax of maximum
                  pressure at midstance.
                  <br></br>
                  <br></br>
                  Co-contractions of the quadriceps and hamstrings stabilize the varying ground reacting forces, passing
                  in front of, behind or through the knee.
                  <br></br>
                  <br></br>
                  While the hip abductors continue their activity to halt the contralateral pelvic drop (also see:
                  pelvic obliquity).
                  <br></br>
                  <br></br>
                  The quadriceps act concentrically to initiate knee extension, and the hip abductors continue their
                  activity, becoming isometric as they halt contralateral pelvic drop.
                </div>
              </IonCol>
            </IonRow>
          </IonGrid>
        </SwiperSlide>

        <SwiperSlide>
          <IonGrid style={{ height: '100%' }}>
            <IonRow class='ion-align-items-center' style={{ height: '100%' }}>
              <IonCol className='ion-no-padding' size='12' size-lg='5' size-xl='5'>
                <div>
                  <IonImg class={styles.avatar} src={IBkneeflexionmidstance2} />
                </div>
              </IonCol>
              <IonCol className='ion-no-padding' size='12' size-lg='5' size-xl='5'>
                <div>
                  If everything works well, the knee should flex within bandwidth of approximately 12 – 25 degrees. Less
                  flexion indicates stiffness. This can be due to overload from prior training – whether due to poor
                  quadricep strength – or fear (typically in rehab from injury or surgery)
                  <br></br>
                  <br></br>
                  Too much flexion typically indicates poor hamstring strength. As a result the impact at heel strike
                  will be clearly audible.
                </div>
              </IonCol>
            </IonRow>
          </IonGrid>
        </SwiperSlide>
      </VerticalSwiper>
    </>
  );
};
